"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var CmeCoach = /*#__PURE__*/_createClass(function CmeCoach(api) {
  var _this = this;
  _classCallCheck(this, CmeCoach);
  this.cmeCoachSearchKey = function () {
    return 'cme-coach/searching';
  };
  this.cmeCoachSearch = function (selectedSpecialtyId, selectedStateId) {
    return function (dispatch, getState) {
      var key = _this.cmeCoachSearchKey();
      var _getState = getState(),
        loading = _getState.loading;
      if (loading.has(key)) return loading.get(key);
      var requestParams = [];
      if (selectedSpecialtyId) requestParams.push("specialty_id=".concat(selectedSpecialtyId));
      if (selectedStateId) requestParams.push("state=".concat(selectedStateId));
      var promise = _this.api.get("cme-coach/search?".concat(requestParams.join('&'))).then(function (response) {
        dispatch({
          type: _constants.CME_COACH_SEARCHED,
          payload: _objectSpread({
            key: key
          }, response)
        });
        return true;
      }).catch(function (error) {
        dispatch({
          type: _constants.CME_COACH_SEARCHED,
          payload: {
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.CME_COACH_SEARCHING,
        payload: {
          key: key,
          selectedSpecialtyId: selectedSpecialtyId,
          selectedStateId: selectedStateId,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.cmeCoachSendEmailKey = function () {
    return "cme-coach/send-email";
  };
  this.cmeCoachSendEmail = function (email) {
    return function (dispatch, getState) {
      var _getState2 = getState(),
        cmeCoach = _getState2.cmeCoach,
        loading = _getState2.loading;
      var key = _this.cmeCoachSendEmailKey();
      if (loading.has(key)) return loading.get(key);
      dispatch({
        type: _constants.CME_COACH_SENDING_EMAIL
      });
      var promise = _this.api.post("cme-coach/send-email", {
        email: email,
        specialty_id: cmeCoach.get('searchedSpecialtyId'),
        state: cmeCoach.get('searchedStateId')
      }).then(function () {
        dispatch({
          type: _constants.CME_COACH_SENT_EMAIL,
          payload: {
            sendEmailStatus: true,
            key: key
          }
        });
        return true;
      }).catch(function (error) {
        dispatch({
          type: _constants.CME_COACH_SENT_EMAIL,
          payload: {
            sendEmailStatus: false,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.CME_COACH_SENDING_EMAIL,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.api = api;
});
var _default = exports.default = CmeCoach;